<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/tags/datatable'"
            actionFild
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            columns: [
                {
                    label: 'Nome',
                    field: 'nome',
                    order: 'tags.nome',
                    sort: 'asc'
                },
                {
                    label: 'Icone',
                    field: 'icone',
                    order: 'tags.icone',
                    sort: 'asc'
                },
                {
                    label: 'Cor',
                    field: 'cor',
                    order: 'tags.cor',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'update',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                }
            ]
    	}
	},
    methods: {
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        }
    }
}
</script>